import {
  CheckoutSessionStatusResponse,
  CreateCheckoutSessionResponse,
  CurrentStatusResponse
} from '../models/api';
import { getData, postData } from './api';
import { ResponseData } from './models';

export const createCheckoutSession = async (
  accountLevel: string
): Promise<ResponseData<CreateCheckoutSessionResponse>> =>
  postData('api/checkout/create-checkout-session', { accountLevel });

export const getSessionStatus = async (
  session_id: string
): Promise<ResponseData<CheckoutSessionStatusResponse>> =>
  getData(`api/checkout/session-status?session_id=${session_id}`);

export const getCurrentStatus = async (): Promise<
  ResponseData<CurrentStatusResponse>
> => getData('api/checkout/current-status');
